import { createCanonicalUrl } from '../url/index'
import type { PathInfoMeta } from './model.types'

export interface ResolverMetaToPageSeoOptions {
  meta: PathInfoMeta
  location: { pathname: string; search?: string }
  defaultNoIndex?: boolean
}

/**
 * Map Brooklyn pathInfo meta to the Redux page SEO payload setPageSeo expects.
 */
export function resolverMetaToPageSeo (options: ResolverMetaToPageSeoOptions) {
  const {
    meta,
    location,
    defaultNoIndex = false,
  } = options
  const canonical = meta.canonicalUrl
    || createCanonicalUrl({ pathname: location.pathname, query: {} })
  const ogImage = meta.ogImage ?? undefined
  return {
    title: meta.title ?? undefined,
    description: meta.description ?? undefined,
    noIndex: meta.robotsNoIndex ?? defaultNoIndex,
    noFollow: meta.robotsNoFollow ?? false,
    canonical,
    ogTitle: meta.ogTitle ?? meta.title ?? undefined,
    ogDescription: meta.ogDescription ?? meta.description ?? undefined,
    ogImage,
    ogImageWidth: meta.ogImageWidth ?? undefined,
    ogImageHeight: meta.ogImageHeight ?? undefined,
    ogType: meta.ogType ?? undefined,
    ogUrl: meta.ogUrl ?? location.pathname,
    twitterTitle: meta.twitterTitle ?? meta.ogTitle ?? meta.title ?? undefined,
    twitterDescription: meta.twitterDescription
      ?? meta.ogDescription
      ?? meta.description
      ?? undefined,
    twitterImage: meta.twitterImage ?? ogImage,
    twitterCard: ogImage ? 'summary_large_image' : undefined,
    location,
  }
}
